import {
  HUMANS_SORT_APLHA_DOWN,
  SET_HUMANS_SORT_ORDER,
} from "../actions/humans";

export default function humansSortOrder(
  state = HUMANS_SORT_APLHA_DOWN,
  action
) {
  switch (action.type) {
    case SET_HUMANS_SORT_ORDER:
      return action.order;

    default:
      return state;
  }
}
